import { isError } from "../../helpers/Error"
import HttpClient from "../../helpers/HttpClient"
import CustomerAccount, { CustomerAccountDto } from "../models/CustomerAccount"

class CustomerAccountService {
    static httpClient: HttpClient<CustomerAccount, CustomerAccountDto> = new HttpClient<CustomerAccount, CustomerAccountDto>(CustomerAccount)

    static async getCustomerAccount(contactId: string): Promise<CustomerAccount> {
        const res = await this.httpClient.get(`/customer-accounts/${contactId}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        
        return res as CustomerAccount
    }
}

export default CustomerAccountService


// WEBPACK FOOTER //
// ./src/state/customer-account/service/CustomerAccountService.ts